export enum Note {
  CourtesyCall = 1,
  Management = 2,
  IncidentReport = 3,
  PerformanceIssue = 4,
  TechLateOrReschedule = 5,
  Confidentional = 6,
  CSSIncident = 7,
  OWIncident = 8,
  BlacklistTechnician = 9,
}

export enum NoteLinkType {
  Customer = 'C',
  Job = 'J',
  Technician = 'T',
}
